import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { addDate } from "keautils";
import { GuiaListMem } from "../../guias/listados/guias/list/listmem";
import { observeResource } from "kea-resource";
import * as globals from "app/resources/globals";


import { FiltroGuiaComponent } from "./filtro";

interface Props {
    permisos: models.Rol;
    Session: models.Session;
    IdSucursal: number;
    filtro: models.FiltroGuiasSucursalZE;
    onFiltroChange: (x: models.FiltroGuiasSucursalZE) => void;
}


/**Listado de todas las guias */
class GuiasListNoRx extends React.PureComponent<Props> {
    constructor(props) {
        super(props);
        const now = new Date();
        this.state = {
            filtro: {
                FechaInicio: addDate(now, "days", -3),
            }
        };
    }
    private VerFiltroClienteOrigenEnConsultaGuias = (props: Props) => props.permisos.Guia.VerFiltroClienteOrigenEnConsultaGuias;
    private filtro = (props: Props) => 
    {
        if (props.permisos.ZonaExtendida.PonerValorDeSucursalFijoEnSelector) {
            props.filtro.IdSucursalZE = props.IdSucursal
        }
        return props.filtro;
    }
    
    private guias = createSelectorRx(this.filtro, filtro => {
        const obs = observeResource(resources.ConsultarGuiaSucursalZE.Query, filtro);
        return obs;
    });

    handleOnLimpiar = async () => {
        await this.props.onFiltroChange({
            IdSucursalStatus: undefined,
            IdSucursalZE: undefined,
            EnSucursalOrigen: undefined,
            EnSucursalDestino: undefined,
            FechaInicio: undefined,
            FechaFinal: undefined,
            IdClienteDestino: undefined,
            IdClienteOrigen: undefined,
            Folio: "",
            StatusGuiaFacturacion: undefined,
            Status: undefined,
            CantPaquetes: undefined,
            CantSobres: undefined,
            FletePorCobrar: undefined,
            EntregaDomicilio: undefined,
            RecoleccionDomicilio: undefined,
            TipoAcuse: undefined,
            ImporteMayorCero: undefined,
            Limite: 100
        });
    }

    render() {
        const guias = this.guias(this.props);
        const verFiltroClienteOrigen = this.VerFiltroClienteOrigenEnConsultaGuias(this.props);
        return (
            <div>
                <kea.Title titulo="Consulta de guías de sucursal de zona extendida" onLimpiar={this.handleOnLimpiar} />
                <FiltroGuiaComponent value={this.filtro(this.props)} Session={this.props.Session} onChange={this.props.onFiltroChange} 
                verClienteOrigen={verFiltroClienteOrigen} />
                <GuiaListMem value={guias} cookieKey="ConsultaGuiasEntregaSucursalZE" />
            </div>
        )
    }
}

const GuiasLisRx = componentToRx(GuiasListNoRx);
const session = resources.User.SessionRx;
const sucursal = resources.User.IdSucursalRx;
/**Listado de todas las guias */
export class GuiaList extends React.PureComponent {
    render() {
        return <GuiasLisRx
            permisos={resources.User.PermisoRx}
            Session={resources.User.SessionRx}
            filtro={globals.state.map(x => x.filtroGuiasConsultaZE)}
            onFiltroChange={x => globals.setState({ filtroGuiasConsultaZE: x })}
            IdSucursal={resources.User.IdSucursalRx}
        />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/consultaguiasentregarze/list/list.tsx